import './globe.css';
import map from '../../assets/svg/Map.svg';

export const MapGlobe = ({ setGlobeShowed, activeToolId }) => {
  const isGreenShowed = activeToolId === 'yellowGround';
  const isYellowShowed = activeToolId === 'greenGround';

  return (
    <div className='globe'>
      <img className='globeMap' src={require('../../assets/map/maps.png')} alt='map3d' />
      <img
        id={isYellowShowed ? 'animation' : ''}
        className='globeMapCover greenMap'
        src={require('../../assets/map/1.maps@3x.png')}
        alt='map3d'
      />
      <img
        id={isGreenShowed ? 'animation' : ''}
        className='globeMapCover'
        src={require('../../assets/map/2.maps@3x.png')}
        alt='map3d'
      />
      <img className='mapBtn' onClick={setGlobeShowed} src={map} alt='map' />
    </div>
  );
};
